export enum USER_PROFILE_INFO_DISCLOSURE_BUTTON_LABEL {
    bookAccess = 'About Book Access',
    bookInvites = 'About Book Invites',
    mailingList = 'About Mailing List',
    commentMail = 'About Comment Mail',
    annotations = 'About Annotations',
    customCursor = 'About Custom Cursor',
    bookmarking = 'About Bookmarking',
    bookInvitePending = 'About Pending invites',
    bookInviteClaimed = 'About Claimed invites',
}
